import { createContext, useContext } from 'react';

/** The order of the letter keys: `qwerty`, or `alphabetical` (A to Z). Both have 10 / 9 / 7 letter rows. */
export type KeyboardLayout = 'qwerty' | 'alphabetical';

export const DEFAULT_KEYBOARD_LAYOUT: KeyboardLayout = 'qwerty';

/** The letter rows of each layout, top to bottom. Backspace and Enter flank the last row. */
export const KEYBOARD_LAYOUT_ROWS: Readonly<Record<KeyboardLayout, readonly string[]>> = {
  qwerty: ['QWERTYUIOP', 'ASDFGHJKL', 'ZXCVBNM'],
  alphabetical: ['ABCDEFGHIJ', 'KLMNOPQRS', 'TUVWXYZ'],
};

/** The player's keyboard layout. Without a `WordsHappenKeyboardLayoutProvider`, it is `qwerty`. */
export const KeyboardLayoutContext = createContext<KeyboardLayout>(DEFAULT_KEYBOARD_LAYOUT);

/** The layout from the nearest `WordsHappenKeyboardLayoutProvider`, or `qwerty` without one. */
export const useKeyboardLayout = (): KeyboardLayout => useContext(KeyboardLayoutContext);
